export default __webpack_public_path__ + "media/zurb/img/case-study-pen-cal/pencal-img3-f277628c6ee4da0cf2451e0fdd4c7165.jpg";